module.exports = __webpack_public_path__ + "static/media/image_6.47af425e.jpg";